// Supervisory review section form field enum
export enum SupervisoryReviewFormField {
  EMPLOYEE = 'employee',
  ID_BADGE = 'idBadge',
  HONORING_RIGHTS = 'honoringRights',
  EMERGENCY_PROTOCOL = 'emergencyProtocol',
  HYGIENE_PRECAUTIONS = 'hygienePrecautions',
  REPORTING_CHANGES = 'reportingChanges',
  GRIEVANCE_COMPLAINT = 'grievanceComplaint',
  POC_DOC_REVIEWED_WITH_CAREGIVER = 'pocDocReviewedWithCaregiver',
  PPE_ACCESS = 'ppeAccess',
  SUPERVISION_OBSERVED = 'supervisionObserved',
  EDUCATION = 'education',
  VERBALLY_UNDERSTOOD = 'verballyUnderstood',
  REPEATED_BACK = 'repeatedBack',
  DEMONSTRATED_SKILL_CORRECTNESS = 'demonstratedSkillCorrectness',
  DOCUMENTATION = 'documentation',
  ADHERED_TO_CARE_PLAN = 'adheredToCarePlan',
  PROFESSIONALISM = 'professionalism',
  SATISFACTION = 'satisfaction',
  COMMENTS = 'comments'
}
